/**
 * Names of all script functions.
 *
 * @module
 */

/** Script function type for `0x1::version::set_version`. */
export const set_version = "0x1::version::set_version" as const;
